import { render, staticRenderFns } from "./EmotionRegulation.vue?vue&type=template&id=e54e1340&scoped=true"
import script from "./EmotionRegulation.vue?vue&type=script&lang=js"
export * from "./EmotionRegulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e1340",
  null
  
)

export default component.exports